/* Trust 1.1.4. Consent-aware loading of the store's existing GTM container. */
(() => {
  'use strict';
  let loaded = false;
  const sync = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' ||
        typeof privacy?.marketingAllowed !== 'function') return;
    const analytics = privacy.analyticsProcessingAllowed() === true;
    const marketing = privacy.marketingAllowed() === true;
    window.iuGoogleConsent?.('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });
    // The existing container can contain tags for both purposes. Fail closed until
    // both are permitted; a future per-tag audit can safely split their loading.
    if (!analytics || !marketing || loaded) return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
    const script = document.createElement('script');
    script.id = 'iu-gtm-script';
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PD93D5CM';
    document.head.appendChild(script);
  };
  const init = () => {
    if (window.Shopify?.customerPrivacy) {
      sync();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        if (!error) sync();
      });
    }
  };
  document.addEventListener('visitorConsentCollected', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();
